export default "__VITE_ASSET__DfXhyZp1__"